// React
import React, { Component } from 'react';
// Redux
import {connect } from "react-redux";
import mapStateToProps from './mapStateToProps';
import mapDispatchToProps from './mapDispatchToProps';
// componentes
import Footer from 'pages/Home/Footer2';
import Title from 'components/TitleWithIcon';
import ComponenteConsultaARenap from './ConsultaRenapPorCui/index'
import {useStyles} from './style';

const EstadisticasSolicitudes = () => {     
    const classes = useStyles();
        return (
            <div className={classes.colorComponente}>
                <Title title={'Consulta de Datos a RENAP'} icon={"/menu/partner.svg"}/>
                <ComponenteConsultaARenap />
                <br/><br/><br/>
            </div>
        )
}

export default connect(mapStateToProps, mapDispatchToProps)(EstadisticasSolicitudes);